import humanizeDuration from 'humanize-duration';
import moment from 'moment';

export const shortEnglishHumanizer = humanizeDuration.humanizer({
  language: 'shortEn',
  languages: {
    shortEn: {
      y: () => 'y',
      mo: () => 'mo',
      w: () => 'w',
      d: () => 'd',
      h: () => 'h',
      m: () => 'm',
      s: () => 's',
      ms: () => 'ms',
    },
  },
});

export const humanizerOptions = { round: true, largest: 3, spacer: '', delimiter: ' ' };

export const abbreviateNumber = (number: number | undefined) => {
  const symbol = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

  if (!number) return 0;

  // Numbers of < 1000 do not get abbreviated
  // This will convert something like 468.64002860980446 to 468.6
  if (number < 1000) return Math.round(number * 10) / 10;

  const tier = (Math.log10(Math.abs(number)) / 3) | 0;

  if (tier == 0) return number;

  const suffix = symbol[tier];
  const scale = Math.pow(10, tier * 3);

  const scaled = number / scale;

  return scaled.toFixed(1) + suffix;
};

export const abbreviateId = (id?: string) => {
  if (!id) return '';
  return id.slice(0, 6) + '...' + id.slice(-6);
};

export const isAddressFromPegaxyTeam = (id?: string) => !!(id?.includes('Pegaxy') || id?.includes('Core'));

export const formatDateTime = (date?: Date) => {
  if (!date) return '';
  return moment(date).format('MMM D, YYYY, h:mm A');
};

export const getRemainingDuration = (date: Date) => {
  const duration = Date.now() - new Date(date).getTime();
  return moment.duration(duration).humanize();
};
